export default __webpack_public_path__ + "static/media/item-3.b4a255ef.webp";